import { DebugFlagsPanel } from "./components/DebugFlagsPanel";

export default function DevDebugFlagsPage() {
  return (
    <div className="flex flex-col items-center p-8">
      <DebugFlagsPanel />
    </div>
  );
}
